import React, { useEffect, useState, useRef } from 'react'
import { Button, Col, Row, Input, notification, Drawer, Select } from 'antd'
import { filterOption, InputBox, Intakes } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import { addAssessmentActivityFxn, notEligibleAssessmentFxn } from '../action/index'
import { listQuickSearchUniversities } from '../../university/actions/university'

const { Option } = Select
const initialFields = {
  universityId: undefined,
  courseName: '',
  campus: '',
  intake: '',
  fees: '',
  initialDeposit: '',
  scholarship: '',
  casDeposit: '',
  initialForInterview: ''
}
const NotEligibleAssessment = (props) => {
  let { visible, onClose,  onSubmit, assessmentId } = props
  const dispatch = useDispatch()
  const [reason, setReason] = useState()

  const handleSubmit = async () => {
    if (!reason) {
      notification.warning({ message: 'Please enter valid reason' })
      return
    }
    let payload = {
      assessmentId:assessmentId,
      reason:reason
    }

    const response = await dispatch(notEligibleAssessmentFxn(payload))
    if(response.success){
      onSubmit()
      setReason('')
    }

  }
  return (
    <Drawer
      visible={visible}
      title='Not Eligible'
      placement='right'
      width={600}
      onClose={() => onClose()}
    >
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <InputBox title={'Please enter reason'}>
              <textarea
                rows={6}
                value={reason}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', borderColor: '#ccc' }}
                placeholder='Enter Reason here...'
                onChange={(e) => setReason(e.target.value)}
              />
            </InputBox>
          </div>
          <Button
            type='primary'
            className='ml10'
            onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </div>
    </Drawer>
  )
}

export default NotEligibleAssessment
